<template>
  <div class="follow_brand">
    <div class="title">
      <span>关注的品牌</span>
    </div>
    <div class="con_tent">
      <ul class="type">
        <li class="type_title">分类：</li>
        <li class="active">全部商品</li>
        <li>沙发</li>
      </ul>
      <ul class="screen">
        <li class="screen_title">筛选条件：</li>
        <li>
          <el-checkbox v-model="checkedAll">全选</el-checkbox>
        </li>
        <li>
          <img :src="require('@/assets/img/my06.png')" alt />
          加入购物车
        </li>
        <li>
          <img :src="require('@/assets/img/my05.png')" alt />
          取消收藏
        </li>
      </ul>
      <div class="brand_list">
        <div class="brand_item" v-for="(item,index) in 2" :key="index">
          <div class="bussiess">
            <div class="logo_img">
              <img :src="require('@/assets/img/pav_logo3.jpg')" alt />
            </div>
            <div class="brand_star">
              <div class="star_box">
                <p>店铺星级</p>
                <el-rate v-model="valueStar" :disabled="true" :allow-half="true" :colors="colorStar"></el-rate>
              </div>
              <div class="num">
                <i class="myicon iconfont icon-heart"></i>
                <span>1465156</span>
              </div>
            </div>
            <div class="customer">
              <div class="into com_link">
                <i class="myicon iconfont icon-jinrudianpu"></i>
                <span>进入店铺</span>
              </div>
              <div class="into com_link">
                <i class="myicon iconfont icon-lianxikefu"></i>
                <span>联系客服</span>
              </div>
            </div>
          </div>
          <div class="goods">
            <div class="soft_box">
              <ul class="soft_left">
                <li class="active">热销</li>
                <li>新品</li>
                <li>活动</li>
              </ul>
              <div class="soft_right">
                <p class="page">
                  <span class="curr_page">1</span>
                  <span>/5</span>
                </p>
                <el-button class="btn" icon="el-icon-arrow-left"></el-button>
                <el-button class="btn" icon="el-icon-arrow-right"></el-button>
              </div>
            </div>
            <ul class="goods_list">
              <li class="list_item" v-for="(item,index) in 6" :key="index">
                <div class="img_box">
                  <img :src="require('@/assets/img/main-2.jpg')" alt />
                </div>
                <div class="price">
                  <span>￥126.00</span>
                </div>
              </li>
            </ul>
            <!-- <ul class="coupon_list">
                <li class="coupon" v-for="(item,index) in 3" :key="index">
                  <h3 class="price">￥40</h3>
                  <p class="reduce">消费满399可用</p>
                  <p class="time">2020.07.01 00:00 — 2020.12.01 00:00</p>
                </li>
              </ul> -->
          </div>
        </div>
      </div>
      <el-pagination class="pagination" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: { title: "收藏品牌 - 个人中心" },
  name: "followBrand",
  data() {
    return {
      checkedAll: false,
      valueStar: 3.5,
      colorStar: ["#ff0000", "#ff0000", "#ff0000"],
      pageInfo: {
        pageNumber: 1,
        pageSize: 2,
        searchProperty: [],
        orderProperty: [],
      },
      total: 80,
    };
  },
  methods: {
    // 分页
    handleCurrentChange(val) {
      console.log(val);
      this.pageInfo.pageNumber = val;
    },
  },
};
</script>

<style lang="less" scoped>
.follow_brand {
  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 31px;
    background: rgba(244, 244, 244, 1);
  }
  .con_tent {
    height: 740px;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    margin: 14px 0 35px;
    padding: 16px 32px 52px 32px;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    overflow: hidden;
    position: relative;
    .type,
    .screen {
      display: flex;
      margin-bottom: 20px;
      li {
        margin-right: 20px;
        cursor: pointer;
      }
      .active {
        color: @themeColor;
      }
    }
    .type_title,
    .screen_title {
      min-width: 70px;
      margin-right: 30px;
    }
    .screen {
      li {
        /deep/ .el-checkbox {
          .el-checkbox__label {
            line-height: 14px;
            padding-left: 6px;
          }
          .el-checkbox__input {
            line-height: 14px;
          }
        }
        img {
          width: 14px;
          height: 14px;
          vertical-align: top;
        }
      }
    }
    .brand_list {
      .brand_item {
        box-sizing: border-box;
        height: 278px;
        border: 1px solid #f4f4f4;
        margin-bottom: 12px;
        display: flex;
        &:last-child {
          margin-bottom: 0;
        }
        .bussiess {
          width: 246px;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #f4f4ff;
          .logo_img {
            width: 100%;
            height: 199px;
            box-sizing: border-box;
            padding-top: 51px;
            overflow: hidden;
            text-align: center;
            img {
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }
          .brand_star {
            height: 19px;
            line-height: 19px;
            padding: 0 15px;
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            .star_box {
              display: flex;
              background: #f4f4f4;
              border-radius: 10px;
              padding: 0 6px;
              /deep/ .el-rate {
                margin-left: 5px;
                .el-rate__icon {
                  font-size: 12px;
                  margin-right: 3px;
                  line-height: 19px;
                  .el-rate__decimal {
                    line-height: 19px;
                  }
                }
              }
            }
            .num {
              .myicon {
                font-size: 14px;
                padding-right: 2px;
                vertical-align: middle;
              }
            }
          }
          .customer {
            line-height: 27px;
            height: 27px;
            border-top: 1px solid #f4f4f4;
            display: flex;
            margin-top: 30px;
            .into {
              width: 50%;
              box-sizing: border-box;
              border-right: 1px solid #f4f4f4;
              text-align: center;
              font-size: 12px;
              &:last-child {
                border: none;
              }
              .myicon {
                font-size: 18px;
                padding-right: 6px;
                vertical-align: middle;
              }
            }
          }
        }
        .goods {
          width: calc(100% - 246px);
          height: 100%;
          box-sizing: border-box;
          padding: 28px 38px 0 28px;
          .soft_box {
            display: flex;
            justify-content: space-between;
            height: 26px;
            line-height: 26px;
            font-size: 12px;
            margin-bottom: 25px;
            .soft_left {
              display: flex;
              box-sizing: border-box;
              border: 1px solid #f4f4f4;
              line-height: 24px;
              li {
                border-right: 1px solid #f4f4f4;
                padding: 0 17px;
                cursor: pointer;
                &:last-child {
                  border: none;
                }
              }
              .active {
                background-color: #ff0000;
                color: #ffffff;
              }
            }
            .soft_right {
              display: flex;
              .page {
                padding-right: 20px;
                .curr_page {
                  color: #ff0000;
                }
              }
              .btn {
                width: 60px;
                padding: 0;
                border-radius: 0;
              }
            }
          }
          .goods_list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 6px;
            .list_item {
              height: 130px;
              width: 100px;
              box-sizing: border-box;
              margin-right: 26px;
              &:last-child {
                margin: 0;
              }
              .img_box {
                width: 100px;
                height: 100px;
                margin-bottom: 14px;
              }
              .price {
                font-size: 16px;
                line-height: 16px;
                text-align: center;
              }
            }
          }
          .coupon_list {
            display: flex;
            .coupon {
              width: 150px;
              height: 58px;
              line-height: 14px;
              box-sizing: border-box;
              margin-right: 20px;
              padding: 4px;
              background-color: rgba(116, 178, 212, 1);
              border-radius: 5px;
              cursor: pointer;
              color: #ffffff;
              .price {
                font-size: 14px;
              }
              .reduce {
                font-size: 12px;
              }
              .time {
                font-size: 12px;
                color: rgba(60, 174, 195, 1);
                line-height: 12px;
              }
            }
          }
        }
      }
    }
    .pagination {
      position: absolute;
      bottom: 20px;
      right: 10px;
    }
  }
}
</style>